import * as angular from 'angular';

import { ComponentDefinition, ITrackableViewModel } from '../../models';

class TrackablePictureController implements angular.IComponentController {
    placement: string;
    trackable: ITrackableViewModel;

    static $inject = [];
}

export const wtTrackablePicture: ComponentDefinition = {
    componentId: 'wtTrackablePicture',
    controller: TrackablePictureController,
    template: require('./trackablePicture.component.html'),
    controllerAs: 'vm',
    bindings: {
        placement: '@?',
        trackable: '<'
    }
};